import { ProfileAvatar } from '../profile-avatar/profile-avatar';
import type { ProfileAvatarProps } from '../profile-avatar/profile-avatar.type';
import { type TextProps } from '@components/atoms';
import { TextTooltip } from '@components/atoms/tooltip/prebuilt/text-tooltip/text-tooltip';

export const UserProfile = ({ name, profilePictureUrl, ...props }: ProfileAvatarProps & TextProps) => {
	return (
		<div className="flex min-w-0 items-center gap-2">
			<ProfileAvatar name={name} profilePictureUrl={profilePictureUrl} />
			<TextTooltip ariaLabel={name} color="primary" weight="medium" {...props}>
				{name}
			</TextTooltip>
		</div>
	);
};
